import React from 'react'
import { useData } from "@/hooks";
import { GATEWAYS_URL, GATEWAYS_LATEST_RELEASE_URL } from "@/api/urls";
import { useUser } from './auth';
const GatewaysContext = React.createContext()

function GatewaysProvider({children, ...props}) {
  const user = useUser() 
  const {data, isFetching, isError, refetch} = useData({
    url: '/api/gateways/',
    refetchInterval: 15000,
    skipFetchIfHidden: true
  })

  //const gateways_related = user && user.gateways_related || [];
  const currentUserGateways = [];
  //data.forEach(m => {
  //  if(gateways_related.includes(m.id)){
  //      m.user_permission = user.perms[+m.id]
  //      currentUserGateways.push(m)
  //    }
  //  }
  //)
  
  return (<GatewaysContext.Provider value={{
    gateways: data, isFetching, isError, refetch, currentUserGateways
    }} {...props}>
    {children}
  </GatewaysContext.Provider>
  )
}


function useGateways() {
  const context = React.useContext(GatewaysContext)
  if (context === undefined) {
    throw new Error(`useGateways must be used within a GatewaysProvider`)
  }
  return context
}

const LatestReleaseContext = React.createContext()

function LatestReleaseProvider({children, ...props}) {
  const {data, isFetching, isError, refetch} = useData({
    url: 'get_latest_gateway_release/'
  })

  return (<LatestReleaseContext.Provider value={{
    changelogs: data?.changelogs, version: data?.version, isFetching, isError, refetch,
    }} {...props}>
    {children}
  </LatestReleaseContext.Provider>
  )
}

function useLatestRelease() {
  const context = React.useContext(LatestReleaseContext)
  if (context === undefined) {
    throw new Error(`useLatestRelease must be used within a LatestReleaseProvider`)
  }
  return context
}

export {GatewaysProvider, useGateways } // LatestReleaseProvider, useLatestRelease